import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-mapping-item-header',
  templateUrl: './mapping-item-header.component.html',
  styleUrls: ['./mapping-item-header.component.scss']
})
export class MappingItemHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
